import { css } from '@emotion/core'
import { colors, measures, zIndexes } from 'styles/variables'

const { unit } = measures

export const wrapper = css`
  position: relative;
`

export const content = css`
  display: flex;
  position: absolute;
  minwidth: ${10 * unit}px;
  background-color: ${colors.white100};
  top: 0;
  left: ${6 * unit}px;
  zindex: ${zIndexes.overlay};
  boxshadow: 0px 0px 2px 1px ${colors.black30};
  transition: opacity 300ms ease;
  visibility: hidden;
  opacity: 0;
`

export const visible = css`
  visibility: visible;
  opacity: 1;
`
